import styled, { css } from 'styled-components';
import { TextInput } from '@prisjakt/ui-inputs';
import * as base from '@prisjakt/ui-base';
import * as UiButton from '@prisjakt/ui-button';
import CheckCircleIcon from 'mdi-react/CheckCircleIcon';
import { Variant } from './types';

export const Legal = styled.div`
  font-size: ${base.layout.measurements.fontSizeSmall};
  margin-top: ${base.layout.spacing.xSmall};
  text-decoration: underline;

  ${base.media.smallOnly`
    font-size: ${base.layout.measurements.fontSizeSmall};
    text-align: center;
  `}
`;

export const Feedback = styled.div`
  font-size: ${base.layout.measurements.fontSizeSmall};
`;

export const Title = styled.div`
  font-size: ${base.layout.measurements.fontSizeMedium};
  font-weight: 600;
  margin-bottom: ${base.layout.spacing.small};
`;

export const SubscribeTitle = styled.b`
  margin-left: ${base.layout.spacing.xSmall};
`;
export const SubscribeSubTitle = styled.div`
  margin-bottom: ${base.layout.spacing.xSmall};
  margin-top: ${base.layout.spacing.xSmall};
`;

export const SubscribedCheckIcon = styled(CheckCircleIcon).attrs(() => ({
  size: '16px',
}))`
  border-radius: 16px;
  background-color: white;
  fill: ${base.colors.green1};
  vertical-align: middle;
`;

export const Form = styled.form`
  margin-bottom: ${base.layout.spacing.xSmall};
`;

type InlineInputProps = { stacked?: boolean };
export const InlineInput = styled(TextInput)<InlineInputProps>`
  flex-grow: 1;

  ${p =>
    !p.stacked &&
    css`
      margin-right: 20px;
      margin-top: 2px;
    `}
`;

export const Flex = styled.div`
  display: flex;
  align-items: top;
  flex-direction: 'row';
  background-color: 'red';
`;

export const Text = styled.div`
  margin-bottom: ${base.layout.spacing.small};
`;

export const Button = styled(UiButton.default)`
  margin-left: ${base.layout.spacing.xSmall};
  height: min-content;
`;

type NewsLetterProps = { variant: Variant } & { stacked: boolean };
export const NewsLetter = styled.div<NewsLetterProps>`
  margin: ${base.layout.spacing.xSmall};
  color: ${p => p.variant === 'secondary' && base.colors.lightTheme.base600};
  ${Title} {
    color: ${p => p.variant === 'secondary' && base.colors.lightTheme.base700};
  }
  ${Legal} a {
    color: ${p =>
      p.variant === 'primary'
        ? base.colors.darkGray4
        : base.colors.lightTheme.base600};

    :hover {
      color: ${p =>
        p.variant === 'primary'
          ? base.colors.darkGray4
          : p.theme.text.callToActionHover};
    }
  }
  ${Feedback} {
    color: ${p =>
      p.variant === 'primary'
        ? base.colors.red1
        : base.colors.lightTheme.base600};
  }
  ${Flex} {
    flex-direction: ${p => (p.stacked ? 'column' : 'row')};
  }
  ${Button} {
    ${p =>
      p.stacked &&
      `margin-left: 0;
    margin-top: ${base.layout.spacing.xSmall};`}
  }
`;
